import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../SEO";

const Blog = ({ mode, title }) => {
  const [blogs, setBlogs] = useState([]);

  // fetch blogs
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/blogs`
        );
        const data = await response.json();
        const responseData = data.data.map((item) => ({
          id: item.id,
          ...(item.attributes || item),
        }));
        setBlogs(responseData);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
   <>
    <SEO
      title="Become a Cybersecurity Expert – Free Learning at PPDDEH"
      description="Learn ethical hacking, coding, and cybersecurity for free at PPDDEH. Gain hands-on skills and become a cybersecurity expert with step-by-step tutorials!"
      url="https://www.ppddeh.com/blog"
    />
   <div className="flex flex-wrap">
      <section className={`w-full text-gray-600 body-font bg-${mode}`}>
        <div className="container px-5 py-24 mx-auto">
          {/* Responsive Grid Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
            {blogs.length > 0 ? (
              blogs.map((blog) => (
                <div key={blog.slug} className="p-4">
                  <div className="h-full border-2 border-gray-500 border-opacity-60 rounded-lg overflow-hidden">
                    {/* Blog Image */}
                    <img
                      className="lg:h-48 md:h-36 w-full object-cover object-center"
                      src={blog.image}
                      alt="blog"
                    />

                    {/* Blog Content */}
                    <div className="p-6">
                      <h1
                        className={`title-font text-lg font-medium text-${
                          mode === "black" ? "white" : "black"
                        } mb-3`}
                      >
                        {blog.title}{" "}
                      </h1>
                      <p className="leading-relaxed mb-3">
                        {blog.shortDescription}{" "}
                      </p>

                      {/* Blog Actions */}
                      <div className="flex items-center flex-wrap">
                        {/* Learn More Link */}
                        <Link
                          to={`/blog/detail/${blog.slug}`}
                          className="text-sky-500 inline-flex items-center md:mb-2 lg:mb-0"
                        >
                          Learn More
                          <svg
                            className="w-4 h-4 ml-2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M5 12h14"></path>
                            <path d="M12 5l7 7-7 7"></path>
                          </svg>
                        </Link>

                        {/* Views */}
                        <span className="text-gray-400 mr-3 inline-flex items-center lg:ml-auto md:ml-0 ml-auto leading-none text-sm pr-3 py-1 border-r-2 border-gray-500">
                          <svg
                            className="w-4 h-4 mr-1"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          1.2K
                        </span>

                        {/* Comments */}
                        <span className="text-gray-400 inline-flex items-center leading-none text-sm">
                          <svg
                            className="w-4 h-4 mr-1"
                            stroke="currentColor"
                            strokeWidth="2"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            viewBox="0 0 24 24"
                          >
                            <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path>
                          </svg>
                          6
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </section>
    </div>
   </>
  );
};

export default Blog;
